import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export default function FolderDropZone({
  children,
  use
}) {
  return /*#__PURE__*/_jsx(View, Object.assign({
    backgroundColor: use === 'default' ? undefined : 'fill-secondary-subtle',
    borderRadius: "200"
  }, use === 'default' ? null : {
    borderWidth: '100',
    borderStyle: 'dashed',
    borderColor: 'border-primary-subtle-pressed'
  }, {
    children: children
  }));
}